import { Link } from 'react-router-dom';
import { DiaryLine } from './DiaryLine';
import { ThemeStack } from './ThemeStack';

export function InterstitialJournaling() {
  return (
    <div className="mt-20 sm:mt-28 md:grid md:grid-cols-[minmax(0,1.1fr)_minmax(0,1fr)] md:items-center md:gap-12">
      <div>
        <DiaryLine time="14:01">
          <h2 className="text-2xl font-semibold tracking-tight text-foreground sm:text-[1.75rem]">
            made for interstitial journaling
          </h2>
        </DiaryLine>

        <DiaryLine className="mt-3">
          <p className="max-w-[58ch] text-pretty text-base leading-relaxed text-muted-foreground sm:text-lg">
            task switching costs: attention residue, time blindness,
            working-memory load. adhd brains pay it hardest. a timestamped line
            per switch handles all&nbsp;three.{' '}
            <Link
              to="/blog/interstitial-journaling-adhd"
              className="whitespace-nowrap font-mono text-sm text-muted-foreground underline decoration-foreground/30 underline-offset-2 transition-colors hover:text-foreground hover:decoration-foreground/60 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
            >
              read more →
            </Link>
          </p>
        </DiaryLine>

        <DiaryLine className="mt-4">
          <Link
            to="/features"
            className="group inline-flex min-h-[44px] items-center font-mono text-sm text-muted-foreground transition-colors hover:text-foreground"
          >
            see everything notetime does
            <span aria-hidden className="ml-1.5 transition-transform group-hover:translate-x-0.5">
              →
            </span>
          </Link>
        </DiaryLine>
      </div>

      {/* The fanned theme tiles double as an interstitial day log: standup,
          shipped, meeting, bedtime. Back cards rise above the front one, so
          the top padding reserves headroom. */}
      <div className="mt-4 flex justify-center pt-12 md:mt-0">
        <ThemeStack className="w-[280px] sm:w-[340px]" />
      </div>
    </div>
  );
}

export default InterstitialJournaling;
